export const SourceMelCategoryCustomer = "melcategorycustomers";

export const TitleMelCategoryCustomer = {
  list: "Mel Category Customer List",
  edit: "Edit Mel Category Customer",
  create: "Create Mel Category Customer",
};
